import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PromoMessage from '../../../app/components/promo-message';
import { MediaQuery as MQ } from '../../../shared/media-query';
import { accScroll } from '../../../shared/page-accordion';
import { hasTouchEvents } from '../../../shared/util';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.subnavs = {
            'your-birth-chart': [
                {
                    text: 'Overview',
                    slug: 'your-birth-chart-overview',
                },
            ],
            'your-report': [
            ],
            'glossary': [
                {
                    text: 'Planets',
                    slug: 'glossary-planets',
                },
                {
                    text: 'Elements',
                    slug: 'glossary-elements',
                },
                {
                    text: 'Houses & Meaning',
                    slug: 'glossary-houses-meaning',
                },
                {
                    text: 'Aspects',
                    slug: 'glossary-aspects',
                },
            ],
        };

        if (props.report) {
            if (props.report.product.birth_chart.planet_table) {
                this.subnavs['your-birth-chart'].push({
                    text: 'Planetary Positions',
                    slug: 'your-birth-chart-planetary-positions',
                });
            }

            if (props.report.product.birth_chart.aspect_grid) {
                this.subnavs['your-birth-chart'].push({
                    text: 'Aspects',
                    slug: 'your-birth-chart-aspects',
                });
            }

            if (props.report.product.birth_chart.aspect_table) {
                this.subnavs['your-birth-chart'].push({
                    text: 'Major Aspects',
                    slug: 'your-birth-chart-major-aspects',
                });
            }

            if (props.report.product.birth_chart.aspect_key) {
                this.subnavs['your-birth-chart'].push({
                    text: 'Aspect Key',
                    slug: 'your-birth-chart-aspect-key',
                });
            }

            if (props.report.product.birth_chart.house_table) {
                this.subnavs['your-birth-chart'].push({
                    text: 'House Positions',
                    slug: 'your-birth-chart-house-positions',
                });
            }

            props.report.product.navigator.map(section => {
                if (section.prefix && section.prefix != '0:' && section.code != 'glossary') {
                    this.subnavs['your-report'].push({
                        text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                        slug: `your-report-${section.code.replace(/_/g, '-')}`,
                    });
                }
            });
        }

        this.state = { mainNavOpen: null };
    }

    componentDidMount() {
        window.addEventListener('click', this.handleGlobalClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.handleGlobalClick);
    }

    /* eslint-disable max-len */
    render({ mainnavs, route }) {
        return (
            <ebr-navigation
                className='is-hidden-print'
                ref={el => this.el = el}
            >
                <ebr-main-nav className={hasTouchEvents && this.state.mainNavOpen ? 'is-touch-open' : ''}>
                    {mainnavs.map(link => {
                        let className = route.match(link.slug) ? 'active' : '';

                        if (!route && link.slug == 'your-birth-chart') {
                            className = 'active';
                        }

                        if (hasTouchEvents) {
                            return (
                                <ebr-main-nav-item className={this.state.mainNavOpen == link.slug ? 'is-touch-open' : ''}>
                                    <a
                                        href={`#${link.slug}`}
                                        className={className}
                                        onClick={this.toggleMainNav}
                                    >
                                        {link.text}
                                    </a>
                                    {this.renderSubNav(link.slug)}
                                </ebr-main-nav-item>
                            );
                        }

                        return (
                            <ebr-main-nav-item className='report-nav-hoverable'>
                                <a
                                    href={`#${link.slug}`}
                                    className={className}
                                >
                                    {link.text}
                                </a>
                                {this.renderSubNav(link.slug)}
                            </ebr-main-nav-item>
                        );
                    })}
                </ebr-main-nav>
            </ebr-navigation>
        );
    }
    /* eslint-enable max-len */

    renderSubNav = (slug) => {
        return (
            <ebr-sub-nav>
                <div>
                    {this.renderPromoMessage(slug)}
                    {this.renderSubNavLinks(slug)}
                </div>
            </ebr-sub-nav>
        );
    }

    renderPromoMessage = (slug) => {
        if (this.props.is_sample && slug == 'your-report') {
            const tags = this.props.code == 'free-birth-chart-redux'
                ? 'ybc,nav'
                : 'ebrsample,nav';

            return (
                <ebr-nav-upgrade>
                    <PromoMessage placement='in-product' tags={tags} />
                </ebr-nav-upgrade>
            );
        }

        return null;
    }

    renderSubNavLinks = (slug) => {
        if (this.subnavs && this.subnavs[slug]) {
            return this.subnavs[slug].map(link => {
                let className = this.props.is_sample && slug == 'your-report' ? 'disabled' : '';

                if (this.props.route.match(link.slug)) {
                    className = `${className} active`;
                }

                return (
                    <a
                        href={`#${link.slug}`}
                        onClick={this.setOpen}
                        className={className}
                    >
                        {link.text}
                    </a>
                );
            });
        }

        return null;
    }

    toggleMainNav = (e) => {
        if (MQ.isMobile() || MQ.isTablet() || hasTouchEvents) {
            const href = e.target.href.replace(/.*#/, '');

            if (href == this.state.mainNavOpen) {
                this.setState({ mainNavOpen: null });
            } else {
                this.setState({ mainNavOpen: href });
            }
        }

        this.setOpen(e, true);
    }

    setOpen = (e, main = false) => {
        e.preventDefault();

        if (!e.target.classList.contains('disabled')) {
            this.props.routeTo(e.target.href.replace(/.*#/, ''));

            if ((MQ.isMobile() || MQ.isTablet() || hasTouchEvents) && e.target.parentNode.tagName == 'DIV') {
                this.setState({ mainNavOpen: null });
            }
        }

        if (!main && e.target && e.target.hash) {
            accScroll(e.target.hash.replace('#', ''), 300);
        }
    }

    handleGlobalClick = (e) => {
        if ((MQ.isMobile() || MQ.isTablet() || hasTouchEvents) && e.target != this.el && !this.el.contains(e.target)) {
            this.setState({ mainNavOpen: null });
        }
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    code: state.report && state.report.product_code,
    is_sample: state.report && state.report.product_code && _.contains([
        'essential-birth-sample',
        'free-birth-chart-redux',
    ], state.report.product_code),
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);